/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class BasesService {
  private baseUrl = `${environment.endpoint}common/bases`;

  constructor(private httpHelperService: HttpHelperService) {}

  async getBases(data?: { majcomId: string }): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/bymajcom`,
        data
      );
    } catch (error) {
      throw error;
    }
  }

  async getBasesByRole(data?: { majcomId: string }): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/byrole`,
        data
      );
    } catch (error) {
      throw error;
    }
  }
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
